/**
 * 精密冰雪科技 (Precision Ice-Snow Tech) Design System
 * TypeScript tokens for JS usage.
 *
 * Keep these values in sync with `src/styles/design-tokens.css`.
 */

export const designTokens = {
  colors: {
    bg: {
      base: '#0A0A0F',
      elevated: '#111118',
      card: '#16161F',
      cardHover: '#1C1C28',
    },
    accent: {
      ice: '#22D3EE',
      blue: '#3B82F6',
      purple: '#6366F1',
      ember: '#F97316',
    },
    status: {
      good: '#10B981',
      ok: '#F59E0B',
      bad: '#EF4444',
      neutral: '#6B7280',
    },
    text: {
      primary: '#F5F5FA',
      secondary: '#B4B4C7',
      tertiary: '#6B6B80',
    },
  },
  fontSize: {
    '4xl': 72,
    '3xl': 56,
    '2xl': 40,
    xl: 28,
    lg: 22,
    md: 18,
    base: 16,
    sm: 14,
    xs: 12,
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 40,
    '2xl': 64,
    '3xl': 96,
  },
  radius: {
    sm: 6,
    md: 12,
    lg: 20,
    full: 9999,
  },
} as const;

/**
 * Default LUT heatmap palette (4-stop blue -> green -> yellow -> red).
 * Each entry is a [stop, color] tuple where stop is in [0, 1].
 */
export const HEATMAP_LUT: [number, string][] = [
  [0.0, '#1e3a8a'], // deep blue (low)
  [0.33, '#22D3EE'], // ice blue
  [0.66, '#F59E0B'], // amber
  [1.0, '#EF4444'], // red (high)
];

/**
 * 5 color schemes including a colorblind-friendly option.
 */
export const COLOR_SCHEMES = {
  default: { name: '默认冰蓝', stops: HEATMAP_LUT },
  ice: {
    name: '极地冰',
    stops: [
      [0, '#0c4a6e'],
      [0.5, '#22D3EE'],
      [1, '#f0f9ff'],
    ] as [number, string][],
  },
  viridis: {
    name: 'Viridis',
    stops: [
      [0, '#440154'],
      [0.25, '#3b528b'],
      [0.5, '#21918c'],
      [0.75, '#5ec962'],
      [1, '#fde725'],
    ] as [number, string][],
  },
  inferno: {
    name: 'Inferno',
    stops: [
      [0, '#000004'],
      [0.25, '#420a68'],
      [0.5, '#932667'],
      [0.75, '#dd513a'],
      [1, '#fcffa4'],
    ] as [number, string][],
  },
  colorblind: {
    name: '色盲友好',
    stops: [
      [0, '#1a1a1a'],
      [0.5, '#8c8c8c'],
      [1, '#ffffff'],
    ] as [number, string][],
  },
} as const;
